module.exports = __webpack_public_path__ + "static/media/IMG_7411-min.bd6fb402.jpeg";